import React, { useEffect, useMemo, useRef, useState } from 'react'
import useSound from 'use-sound'

import neomwithdrawal from '../../../assets/sounds/neomwithdrawal.mp3'
import rainbowwithdrawal from '../../../assets/sounds/rainbowwithdrawal.mp3'
import onicwithdrawal from '../../../assets/sounds/onicwithdrawal.mp3'
import message2 from '../../../assets/sounds/message2.mp3'
import thebitwith from '../../../assets/sounds/thebitwith.mp3'


// 기존 입금 + 출금신청 -> 변경 SoundRepeat2 : 입금신청 , SoundRepeat7 : 출금신청
const SoundRepeat7 = ({ text = '' }) => {

	// const [bell, setBell] = useState<string | null>(null);
	const [refresh, setRefresh] = useState(false);

	let bell = useMemo(() => {
		let sound = message2;
		if (process.env.REACT_APP_NAME === 'NEOM') {
			sound = neomwithdrawal
		} else if (process.env.REACT_APP_NAME === 'RAINBOW') {
			sound = rainbowwithdrawal;
		} else if (process.env.REACT_APP_NAME === 'ONIC') {
			sound = onicwithdrawal
		} else if (process.env.REACT_APP_NAME === 'THEBIT') {
			sound = thebitwith
		} else { // 기본
			sound = message2
		}
		console.log("SOUND", process.env.REACT_APP_NAME);
		return sound
	}, [process.env.REACT_APP_NAME]);

	// useEffect(() => {
	// 	const loadSound = async () => {
	// 	  let sound;
	// 	  if (process.env.REACT_APP_NAME === 'NEOM') {
	// 		sound = await import('../../../assets/sounds/neomwithdrawal.mp3');
	// 	  } else if (process.env.REACT_APP_NAME === 'RAINBOW') {
	// 		sound = await import('../../../assets/sounds/rainbowwithdrawal.mp3');
	// 	  } else if (process.env.REACT_APP_NAME === 'ONIC') {
	// 		sound = await import('../../../assets/sounds/onicwithdrawal.mp3');
	// 	  } else { // 기본
	// 		sound = await import('../../../assets/sounds/message2.mp3'); // 다른 경로 예시
	// 	  }
	// 	  setBell(sound.default);
	// 	};

	// 	loadSound();
	//   }, []);


	const [play, { stop }] = useSound(bell || '', { interrupt: true, volume:process.env.REACT_APP_NAME === 'ONIC'?0.6:1  });

	useEffect(() => {
		console.log("PLAY7");
		play({
			forceSoundEnabled: true,
		});
		setTimeout(() => {
			setRefresh(!refresh);
		}, 60 * 1000 * 5);
	}, [refresh]);

	useEffect(() => {
		setTimeout(() => {
			setRefresh(!refresh);
		}, 200);

		return () => {
			stop();
		};
	}, [stop]);

	return <>{''}</>
}
export default SoundRepeat7
